
export const StatusPill = ({ s }: { s: string }) => {
  // Map existing statuses to variants
  const status = s?.toLowerCase() || "";
  let variant = "neutral";
  
  if (['qualified', 'paid', 'active', 'closed', 'synced', 'success', 'complete'].includes(status)) variant = "success";
  else if (['lost', 'failed', 'error', 'inactive', 'archived', 'destructive'].includes(status)) variant = "error";
  else if (['negotiation', 'pre-negotiation', 'pending', 'syncing...', 'in talks', 'processing'].includes(status)) variant = "pending";
  else if (['warning'].includes(status)) variant = "warning";
  else if (['new'].includes(status)) variant = "neutral";

  const styles = {
    neutral: "bg-neutral-100 text-neutral-600 border-neutral-200",
    success: "bg-green-100 text-green-700 border-green-200",
    error: "bg-red-100 text-red-700 border-red-200",
    pending: "bg-blue-100 text-blue-700 border-blue-200",
    warning: "bg-yellow-100 text-yellow-700 border-yellow-200"
  };

  const label = s ? (s.charAt(0).toUpperCase() + s.slice(1)) : 'Unknown';
  const className = styles[variant as keyof typeof styles];

  return (
    <span className={`inline-flex items-center border px-2 py-0.5 rounded-full text-xs font-medium ${className}`}>
      {label}
    </span>
  );
};
